import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const NavbarWithMenu = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [name, setName] = useState('');
    const [isAdmin, setIsAdmin] = useState(false);


    useEffect(() => {
        const storedName = localStorage.getItem('name');
        const storedIsAdmin = localStorage.getItem('is_admin') === 'true';

        setName(storedName);
        setIsAdmin(storedIsAdmin);
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('name');
        localStorage.removeItem('is_admin');
        navigate('/login');
    };

    return (
        <nav className="navbar navbar-expand-lg navbar-light px-4 navbar-custom" style={{ backgroundColor: '#F1EBE8', fontFamily: 'Atyp Semi, Montserrat', marginLeft: '10%', marginRight: '10%', borderBottom: '3px solid #1D244C' }}>
            <img src="/logo.png" alt="Ep Scan" style={{ height: '40px', marginRight: '40px' }} />
            <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                <span className="navbar-toggler-icon" />
            </button>

            <div className="collapse navbar-collapse" id="navbarNav">
                <ul className="navbar-nav me-auto">
                    {isAdmin ? (<>
                        <li className="nav-item" style={{ marginRight: '20px' }}>
                            <Link className="nav-link text-dark" to="/home" style={{ fontWeight: 'bold', fontSize: '1.25rem', color: location.pathname === '/home' ? '#5768CB' : '#1D244C', display: 'flex', alignItems: 'center', height: '40px' }}><i className="fas fa-tachometer-alt" style={{color: location.pathname === '/home' ? '#5768CB' : '#1D244C', marginRight: '5px'}}></i>Dashboard</Link>
                        </li>
                        <li className="nav-item" style={{ marginRight: '20px' }}>
                            <Link className="nav-link text-dark" to="/admin/users" style={{ fontWeight: 'bold', fontSize: '1.25rem', color: location.pathname === '/admin/users' ? '#5768CB' : '#1D244C', display: 'flex', alignItems: 'center', height: '40px' }}><i className="fas fa-users" style={{color: location.pathname === '/admin/users' ? '#5768CB' : '#1D244C', marginRight: '5px'}}></i>Users</Link>
                        </li>
                        <li className="nav-item" style={{ marginRight: '20px' }}>
                            <Link className="nav-link text-dark" to="/admin/excel" style={{ fontWeight: 'bold', fontSize: '1.25rem', color: location.pathname === '/admin/excel' ? '#5768CB' : '#1D244C', display: 'flex', alignItems: 'center', height: '40px' }}><i className="fas fa-file-excel" style={{color: location.pathname === '/admin/excel' ? '#5768CB' : '#1D244C', marginRight: '5px'}}></i>Excel</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link text-dark" to="/admin/docs" style={{ fontWeight: 'bold', fontSize: '1.25rem', color: location.pathname === '/admin/docs' ? '#5768CB' : '#1D244C', display: 'flex', alignItems: 'center', height: '40px' }}><i className="fas fa-file-word" style={{color: location.pathname === '/admin/docs' ? '#5768CB' : '#1D244C', marginRight: '5px'}}></i>Docs</Link>
                        </li>
                    </>
                    ) : (
                        <li className="nav-item">
                            <Link className="nav-link text-dark" to="/home" style={{ fontWeight: 'bold', fontSize: '1.25rem', color: location.pathname === '/home' ? '#5768CB' : '#1D244C', display: 'flex', alignItems: 'center', height: '40px' }}><i className="fas fa-tachometer-alt" style={{color: location.pathname === '/home' ? '#5768CB' : '#1D244C', marginRight: '5px'}}></i>Dashboard</Link>
                        </li>)
                    }

                </ul>
                <ul className="navbar-nav">
                    <li className="nav-item">
                        <a className="nav-link text-dark" href="#" style={{ color: '#5768CB', display: 'flex', alignItems: 'center', height: '40px' }}><i className="fas fa-search"></i></a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link text-dark" href="#" style={{ color: '#5768CB', display: 'flex', alignItems: 'center', height: '40px' }}><i className="fas fa-bell"></i></a>
                    </li>
                    <li className="nav-item dropdown">
                        <a
                            className="nav-link dropdown-toggle text-dark"
                            href="#"
                            id="navbarDropdownMenuLink"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            style={{ fontWeight: 'bold', fontSize: '1.25rem', display: 'flex', alignItems: 'center', gap: '10px', height: '40px' }}
                        >
                            <div style={{
                                width: '35px',
                                height: '35px',
                                borderRadius: '50%',
                                backgroundColor: '#5768CB',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: 'white',
                                fontWeight: 'bold',
                                fontSize: '1rem'
                            }}>
                                {name ? name.charAt(0).toUpperCase() : 'U'}
                            </div>
                            <span>{name ? name : 'User'}</span>
                        </a>
                        <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdownMenuLink">
                            <li><button className="dropdown-item" onClick={handleLogout}>Logout</button></li>
                        </ul>
                    </li>
                </ul>
            </div>
        </nav>
    );
};

export default NavbarWithMenu;
